import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { ListViewModel } from '../horizontallist/listviewmodel';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { GridViewImpl } from './gridview';
import { GridCSSStyleImpl } from './gridcss';


export interface GridComponentProps<T> extends UIComponentProps
{
    listViewModel: ListViewModel<T>;
}

export class GridComponent<T, S extends UIComponentState> extends UIComponentImpl<GridComponentProps<T>,S, UIDataModel> 
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new GridViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GridCSSStyleImpl(applicationContext);
    }

    componentDidMount()
    {
        window.scrollTo(0,0);
    }
    // componentWillReceiveProps()
    // {
    //     console.log("==========componentWillReceiveProps===" + this.props.listViewModel.getScrollToPosition());

    //     let dto:any = this.props.listViewModel.getItem(this.props.listViewModel.getScrollToPosition());

    //     console.log("==========dto===" + dto.getId());
    //     if(dto !== undefined)
    //     {    

    //        let element = document.getElementById(this.props.listViewModel.getScrollToPosition()+dto.getId());
    //        console.log("==========element===" + element);
    //        if(element !== null && element !== undefined)
    //        {
    //             window.scroll(0,1000);
    //        }
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/grid/gridcomponent.tsx